// extracted by mini-css-extract-plugin
module.exports = {"whiteBoxView":"_2CMEEYB_X4V1WDDzFmJ31J"};